export function getSizeStyles(size) {
  return require("./".concat(size, ".css"));
}